import React from "react";

function FoodProductionField({commodityArr, by}){
	let passedValues = [];
	if(by === "Qty"){
		passedValues = commodityArr.commodityByQtyArr;
	} else {
		passedValues = commodityArr.commodityByValArr;
	}
	return(
		passedValues.map( (passedValue) =>(
			<tr>
				<td>{passedValue["commodity"]}</td>
				{by === "Qty" ? 
					<td>{passedValue["quantity_metric_tonnes_"]}</td>:
					<td>{passedValue["value_1000_int_"]}</td>
				}
			</tr>
		))
	)
}

export default FoodProductionField;